import React from 'react';
import StatusChangeHistory from 'containers/protocol/protocoldetail/components/StatusChangeHistory';
// import IButtonInfo from 'containers/protocol/protocoldetail/components/PrtIButtonInfo';
import EventDocs from 'containers/protocol/cirb/components/EventDocs';
import EditProtocolRelations from 'containers/protocol/opensetup/components/EditProtocolRelations';
import EditEmbededStudies from 'containers/protocol/opensetup/components/EditEmbededStudies';
import { ProtocolSync } from 'containers/protocolbrowser/components';
import CohortChangeHistory from 'containers/protocol/protocoldetail/components/CohortChangeHistory';
import StrataChangeHIstory from 'containers/protocol/protocoldetail/components/StrataChangeHistory';
import UnregisterStudy from 'containers/protocolbrowser/components/UnregisterStudy';


const RSSModalMapper = props => {
  const { modalProps } = props;
  switch (modalProps.type) {
    case 'StatusChangeHistory':
      return <StatusChangeHistory stsChangeHist={modalProps.data} />;
    case 'ProtocolInfo':
      return <div>Work In Progress</div>;
    case 'EventDocs':
      return <EventDocs eventID={modalProps.data} />;
    case 'ProtocolRelations':
      return <EditProtocolRelations data={modalProps.data} defaultRow={modalProps.data} />;
    case 'EmbeddedStudies':
      return <EditEmbededStudies data={modalProps.data} defaultRow={modalProps.data} />;
    case 'SyncProtocol':
      return <ProtocolSync />;
    case 'CohortHistory':
      return <CohortChangeHistory selectedRow={modalProps.data} />;
    case 'StrataHistory':
      return <StrataChangeHIstory selectedRow={modalProps.data} />;
    /*
      RSSMOD-907: https://jira.westat.com/browse/RSSMOD-907
    */
    case 'ProcessStatusChange':
        return `You have requested immediate processing for the pending status change for ${modalProps.data}. If the requested change is not complete within 5 minutes, please contact the CTSU Help Desk at ctsucontact@westat.com.`;
    case 'UnregisteredStudy':
      return <UnregisterStudy />;
      default:
      return null;
  }
};

export default RSSModalMapper;
